// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__13N6s","header":"ClearentDisclaimer_header__navBD","inner":"ClearentDisclaimer_inner__3STZr"};